import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { normalizarValorOrdenacao } from '../../../../../../shared/helpers/ordenacao-tabela.helper';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  ColunaConfiguracao,
  ConfiguracaoColunasModalComponent,
} from '../../../../../../shared/components/configuracao-colunas-modal/configuracao-colunas-modal.component';
import { EmptyListComponent } from '../../../../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { StatusIntegracaoScanntechEnum } from '../../../../../../shared/enums/scanntech/status-integracao-scanntech.enum';
import { AlertService, AlertType } from '../../../../../../shared/services/alert.service';
import { DadosIntegracaoScanntechService } from '../../../../../../shared/services/apis/scanntech/dados-integracao-scanntech.service';
import { MaskService } from '../../../../../../shared/services/mask.service';
import { DadosIntegracaoFechamento } from '../../../../../../shared/services/models/scanntech/dados-integracao-fechamento.model';
import { DadosIntegracaoFechamentoFiltroRequest } from '../../../../../../shared/services/requests/scanntech/dados-integracao-fechamento-filtro.request';
import { LogsIntegracaoDialogComponent } from '../../dialogs/logs-integracao-dialog/logs-integracao-dialog.component';

enum PeriodoEnum {
  SemFiltro = 0,
  Ultimos30Dias = 1,
  DoMes = 2,
  DoIntervalo = 3,
}

interface StatusOption {
  value: StatusIntegracaoScanntechEnum | null;
  label: string;
}

@Component({
  selector: 'app-aba-fechamentos',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    EmptyListComponent,
    LoadingBoxDefaultListComponent,
  ],
  templateUrl: './aba-fechamentos.component.html',
  styleUrl: './aba-fechamentos.component.css',
})
export class AbaFechamentosComponent implements OnInit, OnChanges {
  @Input() ativa: boolean = false;

  public _StatusIntegracaoScanntechEnum = StatusIntegracaoScanntechEnum;
  public PeriodoEnum = PeriodoEnum;

  public model!: FormGroup;
  public _isLoading = false;
  public _dataSource = new MatTableDataSource<DadosIntegracaoFechamento>();
  public _paginaAtual = 0;
  public _ultimaPagina = false;
  public _carregouUmaVez = false;
  public pageSize = 50;
  public totalRegistros = 0;

  public selecao = new SelectionModel<number>(true, []);
  public idLogsCarregando: number | null = null;

  public periodoSelecionado: PeriodoEnum = PeriodoEnum.Ultimos30Dias;
  public periodoIntervaloDe: Date | null = null;
  public periodoIntervaloAte: Date | null = null;

  private periodoSelecionadoAplicado: PeriodoEnum = PeriodoEnum.Ultimos30Dias;
  private periodoIntervaloDeAplicado: Date | null = null;
  private periodoIntervaloAteAplicado: Date | null = null;
  private periodoMenuFoiAplicado = false;

  public statusOptions: StatusOption[] = [
    { value: null, label: 'Todos' },
    { value: StatusIntegracaoScanntechEnum.PendenteEnvio, label: 'Pendente de envio' },
    { value: StatusIntegracaoScanntechEnum.Valido, label: 'Válido' },
    { value: StatusIntegracaoScanntechEnum.Invalido, label: 'Inválido' },
    { value: StatusIntegracaoScanntechEnum.MarcadoParaReprocessamento, label: 'Marcado para reprocessamento' },
    { value: StatusIntegracaoScanntechEnum.NaoIdentificado, label: 'Não identificado' },
  ];

  public displayedColumns: string[] = [];
  public todosCampos: ColunaConfiguracao[] = [
    { def: 'selecao', label: 'Seleção', visible: true, fixed: true },
    { def: 'dataVenda', label: 'Data venda', visible: true, fixed: false },
    { def: 'caixa', label: 'Caixa', visible: true, fixed: false },
    { def: 'idLoteScanntech', label: 'Lote Scanntech', visible: true, fixed: false },
    { def: 'valorTotalVendaLiquida', label: 'Venda líquida', visible: true, fixed: false },
    { def: 'valorTotalVendaCancelada', label: 'Venda cancelada', visible: true, fixed: false },
    { def: 'quantidadeVendaEnviada', label: 'Qtd. vendas', visible: true, fixed: false },
    { def: 'quantidadeVendaCanceladaEnviada', label: 'Qtd. canceladas', visible: true, fixed: false },
    { def: 'status', label: 'Status', visible: true, fixed: false },
    { def: 'ultimoErro', label: 'Último erro', visible: true, fixed: false },
    { def: 'datetimeInclusao', label: 'Inclusão', visible: true, fixed: false },
    { def: 'acoes', label: 'Ações', visible: true, fixed: true, pinnedEnd: true },
  ];

  @ViewChild('periodoMenuTrigger') periodoMenuTrigger?: MatMenuTrigger;
  @ViewChild(MatSort) set sort(sort: MatSort | undefined) {
    if (!sort) return;
    this._dataSource.sort = sort;
  }

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private dialog: MatDialog,
    private dadosIntegracaoService: DadosIntegracaoScanntechService
  ) {}

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      pesquisa: [''],
      caixa: [null],
      statusIntegracaoScanntech: [null],
    });

    this.setPeriodoUltimos30Dias();
    this.salvarPeriodoAplicado();
    this.atualizarColunasVisiveis();
    this.configurarOrdenacao();

    if (this.ativa) this.clickPesquisar();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.model) return;
    if (changes['ativa'] && this.ativa && !this._carregouUmaVez) this.clickPesquisar();
  }

  public get quantidadeSelecionada(): number {
    return this.selecao.selected.length;
  }

  public get quantidadeSelecionadaParaHabilitar(): number {
    return this.fechamentosSelecionados.filter(f => this.podeHabilitarReprocessamento(f)).length;
  }

  public get quantidadeSelecionadaParaDesabilitar(): number {
    return this.fechamentosSelecionados.filter(f => this.podeDesabilitarReprocessamento(f)).length;
  }

  public atualizar(): void {
    this.clickPesquisar();
  }

  public clickPesquisar(): void {
    this._paginaAtual = 0;
    this._dataSource.data = [];
    this._ultimaPagina = false;
    this.selecao.clear();
    this.pesquisar();
  }

  public proximaPagina(): void {
    if (this._isLoading || this._ultimaPagina) return;
    this._paginaAtual++;
    this.pesquisar();
  }

  public limparFiltros(): void {
    this.model.patchValue({
      pesquisa: '',
      caixa: null,
      statusIntegracaoScanntech: null,
    });
    this.setPeriodoUltimos30Dias();
    this.salvarPeriodoAplicado();
    this.clickPesquisar();
  }

  public aplicarFiltros(): void {
    this.onNumberBlur('caixa');
    this.clickPesquisar();
  }

  public get qtdFiltrosAvancados(): number {
    if (!this.model) return 0;
    let total = 0;
    if (this.model.get('caixa')?.value) total++;
    if (this.model.get('statusIntegracaoScanntech')?.value !== null) total++;
    return total;
  }

  public prepararPeriodoIntervalo(): void {
    this.periodoMenuFoiAplicado = false;
    if (this.periodoSelecionado === PeriodoEnum.DoIntervalo && (!this.periodoIntervaloDe || !this.periodoIntervaloAte)) {
      this.setPeriodoUltimos7DiasIntervalo();
    }
  }

  public onPeriodoMenuClosed(): void {
    if (!this.periodoMenuFoiAplicado) this.restaurarPeriodoAplicado();
  }

  public cancelarPeriodoIntervalo(trigger?: MatMenuTrigger): void {
    this.restaurarPeriodoAplicado();
    this.periodoMenuFoiAplicado = true;
    setTimeout(() => (trigger ?? this.periodoMenuTrigger)?.closeMenu());
  }

  public aplicarPeriodo(trigger?: MatMenuTrigger): void {
    if (this.periodoSelecionado === PeriodoEnum.DoIntervalo) {
      if (!this.periodoIntervaloDe || !this.periodoIntervaloAte) {
        this.alertService.show('Atenção', 'Informe as duas datas do intervalo para aplicar o filtro.', AlertType.warning);
        return;
      }

      if (this.periodoIntervaloAte < this.periodoIntervaloDe) {
        this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
        return;
      }
    }

    this.periodoMenuFoiAplicado = true;
    this.salvarPeriodoAplicado();
    this.clickPesquisar();
    setTimeout(() => (trigger ?? this.periodoMenuTrigger)?.closeMenu());
  }

  public selecionarPeriodo(periodo: PeriodoEnum): void {
    this.periodoSelecionado = periodo;
    if (periodo === PeriodoEnum.DoIntervalo) this.setPeriodoUltimos7DiasIntervalo();
  }

  public onDateInput(event: Event): void {
    MaskService.onDateInput(event);
  }

  public onDateKeydown(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
    const isAtalho = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
    if (teclasPermitidas.includes(event.key) || isAtalho) return;
    if (!/^\d$/.test(event.key)) event.preventDefault();
  }

  public onDateBlur(event: FocusEvent, campo: 'de' | 'ate'): void {
    const input = event.target as HTMLInputElement;
    const valor = input?.value?.trim() || '';
    if (!valor) {
      this.atualizarCampoIntervalo(campo, null);
      return;
    }

    const apenasNumeros = valor.replace(/\D/g, '').substring(0, 8);
    if (apenasNumeros.length !== 8) {
      input.value = '';
      this.atualizarCampoIntervalo(campo, null);
      return;
    }

    const formatado = `${apenasNumeros.substring(0, 2)}/${apenasNumeros.substring(2, 4)}/${apenasNumeros.substring(4, 8)}`;
    input.value = formatado;
    const data = this.parseDataBr(formatado);
    if (!data) {
      this.atualizarCampoIntervalo(campo, null);
      this.alertService.show('Atenção', 'Informe uma data válida no formato DD/MM/AAAA.', AlertType.warning);
      return;
    }

    this.onPeriodoIntervaloChange(campo, data);
  }

  public onPeriodoIntervaloChange(campo: 'de' | 'ate', valor: Date | null): void {
    if (!valor) {
      this.atualizarCampoIntervalo(campo, null);
      return;
    }

    const dataNormalizada = new Date(valor);
    dataNormalizada.setHours(0, 0, 0, 0);
    this.atualizarCampoIntervalo(campo, dataNormalizada);

    if (this.periodoIntervaloDe && this.periodoIntervaloAte && this.periodoIntervaloAte < this.periodoIntervaloDe) {
      if (campo === 'de') this.periodoIntervaloAte = null;
      else this.periodoIntervaloDe = null;
      this.alertService.show('Atenção', 'O intervalo de datas informado é inválido.', AlertType.warning);
    }
  }

  public onNumberKeydown(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
    const isAtalho = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
    if (teclasPermitidas.includes(event.key) || isAtalho) return;
    if (!/^\d$/.test(event.key)) event.preventDefault();
  }

  public onNumberBlur(controlName: string): void {
    const valor = this.model.get(controlName)?.value;
    if (valor === null || valor === undefined || valor === '') return;
    const numerico = String(valor).replace(/\D/g, '');
    this.model.get(controlName)?.setValue(numerico ? Number(numerico) : null);
  }

  public get periodoLabel(): string {
    switch (this.periodoSelecionado) {
      case PeriodoEnum.SemFiltro:
        return 'sem filtro';
      case PeriodoEnum.Ultimos30Dias:
        return 'últimos 30 dias';
      case PeriodoEnum.DoMes:
        return 'do mês';
      case PeriodoEnum.DoIntervalo:
        return 'do intervalo';
      default:
        return 'últimos 30 dias';
    }
  }

  public isTodosSelecionados(): boolean {
    const selecionaveis = this._dataSource.data.filter(f => this.podeSelecionar(f));
    return selecionaveis.length > 0 && selecionaveis.every(f => this.selecao.isSelected(f.idSomatorioFechamentoDiario));
  }

  public alternarTodos(): void {
    const selecionaveis = this._dataSource.data.filter(f => this.podeSelecionar(f));
    if (this.isTodosSelecionados()) {
      selecionaveis.forEach(f => this.selecao.deselect(f.idSomatorioFechamentoDiario));
      return;
    }
    selecionaveis.forEach(f => this.selecao.select(f.idSomatorioFechamentoDiario));
  }

  public marcarSelecionadosReprocessamento(): void {
    const idsElegiveis = this.fechamentosSelecionados
      .filter(f => this.podeHabilitarReprocessamento(f))
      .map(f => f.idSomatorioFechamentoDiario);
    this.marcarReprocessamento(idsElegiveis);
  }

  public desmarcarSelecionadosReprocessamento(): void {
    const idsElegiveis = this.fechamentosSelecionados
      .filter(f => this.podeDesabilitarReprocessamento(f))
      .map(f => f.idSomatorioFechamentoDiario);
    this.desmarcarReprocessamento(idsElegiveis);
  }

  public marcarLinhaReprocessamento(fechamento: DadosIntegracaoFechamento): void {
    if (!this.podeHabilitarReprocessamento(fechamento)) return;
    this.marcarReprocessamento([fechamento.idSomatorioFechamentoDiario]);
  }

  public desmarcarLinhaReprocessamento(fechamento: DadosIntegracaoFechamento): void {
    if (!this.podeDesabilitarReprocessamento(fechamento)) return;
    this.desmarcarReprocessamento([fechamento.idSomatorioFechamentoDiario]);
  }

  public podeHabilitarReprocessamento(fechamento: DadosIntegracaoFechamento): boolean {
    return fechamento.statusIntegracaoScanntech !== StatusIntegracaoScanntechEnum.Valido && !fechamento.reprocessar;
  }

  public podeDesabilitarReprocessamento(fechamento: DadosIntegracaoFechamento): boolean {
    return fechamento.reprocessar;
  }

  public podeSelecionar(fechamento: DadosIntegracaoFechamento): boolean {
    return this.podeHabilitarReprocessamento(fechamento) || this.podeDesabilitarReprocessamento(fechamento);
  }

  public getHintSelecao(fechamento: DadosIntegracaoFechamento): string {
    if (this.podeSelecionar(fechamento)) return '';
    if (fechamento.statusIntegracaoScanntech === StatusIntegracaoScanntechEnum.Valido) {
      return 'Fechamento válido não pode ser habilitado para reprocessamento.';
    }
    return 'Este fechamento não possui ação de reprocessamento disponível no momento.';
  }

  public getHintVerMais(): string {
    return this._isLoading ? 'Aguarde o carregamento da lista para buscar mais registros.' : '';
  }

  public verLogs(idSomatorioFechamentoDiario: number): void {
    this.idLogsCarregando = idSomatorioFechamentoDiario;
    this.dadosIntegracaoService.listarLogsFechamento(idSomatorioFechamentoDiario).subscribe({
      next: response => {
        this.idLogsCarregando = null;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.dialog.open(LogsIntegracaoDialogComponent, {
          maxWidth: '96vw',
          width: '1040px',
          data: {
            titulo: 'Logs do fechamento',
            subtitulo: `Somatório ${idSomatorioFechamentoDiario}`,
            logs: (response.listaLog ?? []).map(log => ({
              id: log.idLogFechamentoDiario,
              data: log.data,
              dataHoraInclusao: log.datetimeInclusao,
              idLoteScanntech: log.idLoteScanntech,
              identificador: log.idLoteFechamentoDiario ? `Lote fechamento ${log.idLoteFechamentoDiario}` : undefined,
              codigo: log.appErrorCodeScanntech,
              mensagem: log.mensagem,
              url: log.url,
            })),
          },
        });
      },
      error: error => {
        this.idLogsCarregando = null;
        this.alertService.show('Erro inesperado', error?.message || error, AlertType.error);
      },
    });
  }

  public getStatusBadgeClass(status: StatusIntegracaoScanntechEnum): string {
    switch (status) {
      case StatusIntegracaoScanntechEnum.Valido:
        return 'status-badge badge-verde';
      case StatusIntegracaoScanntechEnum.Invalido:
        return 'status-badge badge-vermelho';
      case StatusIntegracaoScanntechEnum.MarcadoParaReprocessamento:
      case StatusIntegracaoScanntechEnum.PendenteEnvio:
        return 'status-badge badge-amarelo';
      default:
        return 'status-badge badge-cinza';
    }
  }

  public getStatusLabel(status: StatusIntegracaoScanntechEnum): string {
    switch (status) {
      case StatusIntegracaoScanntechEnum.Valido:
        return 'Válido';
      case StatusIntegracaoScanntechEnum.Invalido:
        return 'Inválido';
      case StatusIntegracaoScanntechEnum.MarcadoParaReprocessamento:
        return 'Marcado para reprocessamento';
      case StatusIntegracaoScanntechEnum.PendenteEnvio:
        return 'Pendente de envio';
      default:
        return 'Não identificado';
    }
  }

  public configurarColunas(): void {
    const dialogRef = this.dialog.open(ConfiguracaoColunasModalComponent, {
      maxWidth: '700px',
      data: { colunas: this.todosCampos },
    });

    dialogRef.afterClosed().subscribe((result: ColunaConfiguracao[]) => {
      if (!result) return;
      this.todosCampos = result;
      this.atualizarColunasVisiveis();
    });
  }

  private pesquisar(): void {
    if (this._isLoading) return;
    this._isLoading = true;
    const request = this.montarRequest();

    this.dadosIntegracaoService.listarFechamentos(request).subscribe({
      next: response => {
        this._isLoading = false;
        this._carregouUmaVez = true;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        const novos = response.listaDadosIntegracaoFechamento ?? [];
        const acumulado = this._paginaAtual === 0 ? novos : [...this._dataSource.data, ...novos];
        this._dataSource.data = acumulado;
        this.totalRegistros = response.fullListSize ?? response.totalRegistros ?? 0;
        this._ultimaPagina = !novos.length || acumulado.length >= this.totalRegistros;
      },
      error: error => {
        this._isLoading = false;
        this._carregouUmaVez = true;
        this.alertService.show('Erro inesperado', error?.message || error, AlertType.error);
      },
    });
  }

  private montarRequest(): DadosIntegracaoFechamentoFiltroRequest {
    const datas = this.getDatasPeriodo();
    return {
      pesquisa: this.valorTexto('pesquisa'),
      caixa: this.model.get('caixa')?.value ?? null,
      statusIntegracaoScanntech: this.model.get('statusIntegracaoScanntech')?.value ?? null,
      dataInicial: datas.inicio ? this.formatarDataInicial(datas.inicio) : null,
      dataFinal: datas.fim ? this.formatarDataFinal(datas.fim) : null,
      pageIndex: this._paginaAtual,
      pageSize: this.pageSize,
    };
  }

  private marcarReprocessamento(idsSomatorioFechamentoDiario: number[]): void {
    if (!idsSomatorioFechamentoDiario.length) {
      this.alertService.show('Atenção', 'Selecione ao menos um fechamento inválido ou pendente que ainda não esteja habilitado para reprocessamento.', AlertType.warning);
      return;
    }

    this.dadosIntegracaoService.marcarFechamentosParaReprocessamento({ idsSomatorioFechamentoDiario }).subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', `${idsSomatorioFechamentoDiario.length} fechamento(s) habilitado(s) para reprocessamento.`, AlertType.success);
        this.clickPesquisar();
      },
      error: error => this.alertService.show('Erro inesperado', error?.message || error, AlertType.error),
    });
  }

  private desmarcarReprocessamento(idsSomatorioFechamentoDiario: number[]): void {
    if (!idsSomatorioFechamentoDiario.length) {
      this.alertService.show('Atenção', 'Selecione ao menos um fechamento habilitado para reprocessamento.', AlertType.warning);
      return;
    }

    this.dadosIntegracaoService.desmarcarFechamentosParaReprocessamento({ idsSomatorioFechamentoDiario }).subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', `${idsSomatorioFechamentoDiario.length} fechamento(s) desabilitado(s) para reprocessamento.`, AlertType.success);
        this.clickPesquisar();
      },
      error: error => this.alertService.show('Erro inesperado', error?.message || error, AlertType.error),
    });
  }

  private valorTexto(controlName: string): string | null {
    const valor = this.model.get(controlName)?.value?.trim();
    return valor || null;
  }

  private get fechamentosSelecionados(): DadosIntegracaoFechamento[] {
    const idsSelecionados = new Set(this.selecao.selected);
    return this._dataSource.data.filter(f => idsSelecionados.has(f.idSomatorioFechamentoDiario));
  }

  private cloneDate(data: Date | null): Date | null {
    return data ? new Date(data) : null;
  }

  private salvarPeriodoAplicado(): void {
    this.periodoSelecionadoAplicado = this.periodoSelecionado;
    this.periodoIntervaloDeAplicado = this.cloneDate(this.periodoIntervaloDe);
    this.periodoIntervaloAteAplicado = this.cloneDate(this.periodoIntervaloAte);
  }

  private restaurarPeriodoAplicado(): void {
    this.periodoSelecionado = this.periodoSelecionadoAplicado;
    this.periodoIntervaloDe = this.cloneDate(this.periodoIntervaloDeAplicado);
    this.periodoIntervaloAte = this.cloneDate(this.periodoIntervaloAteAplicado);
  }

  private setPeriodoUltimos30Dias(): void {
    this.periodoSelecionado = PeriodoEnum.Ultimos30Dias;
    this.periodoIntervaloDe = null;
    this.periodoIntervaloAte = null;
  }

  private setPeriodoUltimos7DiasIntervalo(): void {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const seteDiasAtras = new Date(hoje);
    seteDiasAtras.setDate(hoje.getDate() - 6);
    this.periodoIntervaloDe = seteDiasAtras;
    this.periodoIntervaloAte = hoje;
  }

  private atualizarCampoIntervalo(campo: 'de' | 'ate', data: Date | null): void {
    if (campo === 'de') this.periodoIntervaloDe = data;
    else this.periodoIntervaloAte = data;
  }

  private parseDataBr(valor: string): Date | null {
    const partes = valor.split('/');
    if (partes.length !== 3) return null;
    const dia = Number(partes[0]);
    const mes = Number(partes[1]);
    const ano = Number(partes[2]);
    if (!Number.isInteger(dia) || !Number.isInteger(mes) || !Number.isInteger(ano)) return null;
    if (ano < 1000 || ano > 9999 || mes < 1 || mes > 12 || dia < 1 || dia > 31) return null;
    const data = new Date(ano, mes - 1, dia);
    data.setHours(0, 0, 0, 0);
    if (data.getFullYear() !== ano || data.getMonth() !== mes - 1 || data.getDate() !== dia) return null;
    return data;
  }

  private getDatasPeriodo(): { inicio: Date | null; fim: Date | null } {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    switch (this.periodoSelecionado) {
      case PeriodoEnum.SemFiltro:
        return { inicio: null, fim: null };
      case PeriodoEnum.Ultimos30Dias: {
        const trintaDiasAtras = new Date(hoje);
        trintaDiasAtras.setDate(hoje.getDate() - 30);
        return { inicio: trintaDiasAtras, fim: hoje };
      }
      case PeriodoEnum.DoMes:
        return { inicio: new Date(hoje.getFullYear(), hoje.getMonth(), 1), fim: new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0) };
      case PeriodoEnum.DoIntervalo:
        return { inicio: this.periodoIntervaloDe, fim: this.periodoIntervaloAte };
      default:
        return { inicio: null, fim: null };
    }
  }

  private formatarDataInicial(data: Date): string {
    return this.formatarDataLocal(data, '00:00:00');
  }

  private formatarDataFinal(data: Date): string {
    return this.formatarDataLocal(data, '23:59:59');
  }

  private formatarDataLocal(data: Date, hora: string): string {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}T${hora}`;
  }

  private atualizarColunasVisiveis(): void {
    this.displayedColumns = this.todosCampos.filter(c => c.visible).map(c => c.def);
  }

  private configurarOrdenacao(): void {
    this._dataSource.sortingDataAccessor = (item, property): string | number => {
      switch (property) {
        case 'dataVenda':
          return normalizarValorOrdenacao(new Date(item.dataVenda).getTime());
        case 'datetimeInclusao':
          return normalizarValorOrdenacao(new Date(item.datetimeInclusao).getTime());
        case 'status':
          return normalizarValorOrdenacao(item.statusIntegracaoScanntech ?? 0);
        default:
          return normalizarValorOrdenacao((item as unknown as Record<string, string | number>)[property] ?? '');
      }
    };
  }
}
